import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircle } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import { supabase } from '../lib/supabase';

interface UserMenuProps {
  email: string;
}

export function UserMenu({ email }: UserMenuProps) {
  const navigate = useNavigate();
  const { user } = useSession();

  const handleClick = async () => {
    if (user) {
      // Get user type from profiles table
      const { data } = await supabase
        .from('profiles')
        .select('user_type')
        .eq('id', user.id)
        .single();

      if (data) {
        // Navigate to the appropriate settings page with user tab active
        switch (data.user_type) {
          case 'hotel':
            navigate('/extranet/hotel', { state: { settingsTab: 'user' } });
            break;
          case 'saas':
            navigate('/extranet/saas', { state: { settingsTab: 'user' } });
            break;
          case 'internal':
            navigate('/extranet/internal', { state: { settingsTab: 'user' } });
            break;
          default:
            navigate('/settings');
        }
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center space-x-2 text-gray-600"
    >
      <UserCircle className="h-6 w-6" />
      <span className="text-sm font-medium flex-1 text-left truncate">{email}</span>
    </button>
  );
}